if (typeof DynaCore_Grid == 'undefined') {
    var DynaCore_Grid =
    {
        /**
         * Vyber sloupecku, ktere chce uzivatel videt v gridu
         *
         * Ulozi vybrane sloupce do nastaveni uzivatele
         */
        columns: function (grid, gridName) {
            $(grid).jqGrid('columnChooser', {
                done: function (perm) {
                    if (perm) {
                        this.jqGrid('remapColumns', perm, true);
                        $('#' + gridName).setGridWidth($('#gbox_' + gridName).parent().width());
                    }
                }
            });
        },

        clear: function (grid, gridName) {
            var gridSelector = $('#' + gridName);
            gridSelector.jqGrid('clearGridData', true);
            gridSelector[0].clearToolbar();
            gridSelector.trigger('reloadGrid');
        },

        /**
         * Nastaveni pro export dat z gridu
         *
         * @param grid
         * @param gridName
         */
        exportData: function (grid, gridName) {
            var url = '/core/grid/export?_name=' + gridName;

            var ch = $('#_ch');
            if (ch.length) {
                url += '&_ch=' + ch.val();
            }

            $(document).load(url, function (form) {
                Lemo_Modal
                    .setId('modal-container-grid-export-data')
                    .setTitle('Export of data')
                    .setContent(form)
                    .addButton('export', '<i class="fas fa-fw fa-download"></i> ' + translate('Export'), 'btn btn-primary', function () {
                        var formGridExport = $('#formGridExport');
                        var rows = formGridExport.find('#rows').val();
                        var cols = formGridExport.find('#cols').val();
                        var filename = formGridExport.find('#filename').val();
                        var format = formGridExport.find('#format').val();
                        var rowsSelected = {};
                        var colsVisible = {};

                        var spellOutCurrency = 0;
                        if (true === formGridExport.find('#spellOutCurrency').prop("checked")) {
                            var spellOutCurrency = 1;
                        }

                        // Maji se exportovat jen vybrane radky, nacteme si je
                        if ('selected' === rows) {
                            rowsSelected = $(grid).jqGrid('getGridParam', 'selarrrow');
                        }

                        // Maji se exportovat jen viditelne sloupce, nacteme si je
                        $($(grid).jqGrid('getGridParam', 'colModel')).each(function (i, col) {
                            var isVisible = true;

                            if (typeof col.hidden != 'undefined' && col.hidden === true) {
                                isVisible = false;
                            }

                            colsVisible[col.name] = isVisible;
                        });

                        $.ajax({
                            type: 'post',
                            url: url,
                            data: {
                                filename: filename,
                                format: format,
                                gridName: gridName,
                                rows: rows,
                                rowsSelected: rowsSelected,
                                cols: cols,
                                colsVisible: colsVisible,
                                spellOutCurrency: spellOutCurrency
                            },
                            dataType: "json",
                            global: false,
                            success: function (data) {
                                Lemo_Modal.close();
                                DynaCore_Grid.exportProgress(gridName, data.hash);
                            },
                            error: function (html) {
                                Lemo_Alert.addDanger('Some form fields are not filled up or not filled correctly', 'gridExportError');

                                $('#dialogBody').html(html.responseText);
                            }
                        });
                    })
                    .addButton('cancel', 'Cancel', 'btn btn-default', function () {
                        Lemo_Modal.close();
                    });

                Lemo_Modal.build();
            });
        },

        exportProgress: function (gridName, exportHash) {

            "use strict";
            var progressId = null;

            var url = '/core/grid/export-progress?_name=' + gridName + '&exportHash=' + exportHash;
            var ch = $('#_ch');
            if (ch.length) {
                url += '&_ch=' + ch.val();
            }

            $.ajax({
                type: 'get',
                url: url,
                global: true,
                dataType: 'json',
                beforeSend: function () {
                    var text = '<p>' + translate('Export of data') + ' ... <span id="export-progress-eta"></span></p>';
                    text += '<div id="export-progress" class="progress text-center mt-1 mb-2">';
                    text += '    <div class="progress-bar progress-bar-striped active" role="progressbar" style="width: 0%;">0%</div>';
                    text += '</div>';
                    text += '<button id="button-export-cancel" class="btn btn-xs btn-danger"><i class="fas fa-trash fa-fw"></i> ' + translate('Cancel export') + '</button>';
                    Lemo_Alert.setShowCloseButton(false);
                    Lemo_Alert.setCloseOnClick(false);
                    Lemo_Alert.addInfo(text, 'exportData', 0);

                    progressId = window.setInterval(function () {
                        DynaCore_Grid.exportProgressInfo(exportHash);
                    }, 2500);

                    var btnCancel = $('#button-export-cancel');
                    if (btnCancel.length) {
                        btnCancel.on('click', function (e) {
                            e.preventDefault();
                            DynaCore_Grid.exportCancel(exportHash);
                        });
                    }
                },
                success: function (data) {
                    if (data.hasOwnProperty('canceled') && true === data.canceled) {
                        return;
                    }
                    if (data.hasOwnProperty('error') && null !== data.error) {
                        Lemo_Alert.addDanger(data['error'], 'exportError');
                    }
                    if (data.hasOwnProperty('status') && true === data.status) {
                        Lemo_Alert.addInfo('Vyčkejte na stažení souboru', 'exportDownloadInfo', 2500);
                        setTimeout(function() {
                            Lemo_Alert.closeById('exportDownloadInfo');
                            window.location.replace('/core/grid/export-download?exportHash=' + exportHash);
                        }, 3000);
                    }
                },
                complete: function () {
                    if (null !== progressId) {
                        window.clearInterval(progressId);
                    }
                    Lemo_Alert.closeById('exportData');
                },
                error: function (xhr) {
                    Lemo_Alert.addDanger(translate('An unexpected error occurred') + ': ' + xhr.getError(), 'exportError');
                }
            });
        },

        exportProgressInfo: function (exportHash) {
            $.ajax({
                type: 'post',
                url: '/core/grid/export-progress-info',
                data: {'exportHash': exportHash},
                dataType: "json",
                global: false,
                success: function (data) {
                    var progressBar = $('#export-progress');
                    if (progressBar.length) {
                        progressBar.find('.progress-bar').text(data.procent + '%');
                        progressBar.find('.progress-bar').css('width', data.procent + '%');
                    }
                    var progressBarEta = $('#export-progress-eta');
                    if (progressBarEta.length) {
                        if (null !== data.eta) {
                            progressBarEta.text(' ' + translate('Remaining') +': ' + data.eta);
                        } else {
                            progressBarEta.text(' ' + translate('Unknown remaining time'));
                        }
                    }
                }
            });
        },

        exportCancel: function(exportHash) {
            $.ajax({
                type: 'post',
                url: '/core/grid/export-cancel',
                data: {'exportHash': exportHash},
                dataType: "json",
                global: false,
                success: function (data) {
                    Lemo_Alert.addInfo(translate('Export was canceled'), 'exportDataCancel', 5000);
                    Lemo_Alert.closeById('exportData');
                }
            });
        },

        reset: function (grid, gridName) {
            var colFirstSortable = '';
            var colModel = $(grid).jqGrid('getGridParam', 'colModel');

            $(colModel).each(function (i, col) {
                if (true === col.search) {
                    colFirstSortable = col.name;
                    return false;
                }
            });

            $('#gbox_' + gridName).find('.s-ico > span').addClass('ui-state-disabled');
            $('#jqgh_' + gridName + '_' + colFirstSortable).find('.ui-icon-asc').removeClass('ui-state-disabled');

            var gridSelector = $('#' + gridName);
            gridSelector
                .jqGrid('setGridParam', {page: 1, sortname: colFirstSortable, sortorder: 'asc'})
                .trigger('clearToolbar')
                .trigger('clearData')
                .trigger('reloadGrid');
        },

        resize: function (grid, width, index) {
            var colModel = $(grid).jqGrid('getGridParam', 'colModel');
            var columnName = colModel[index].name;

            $(grid).jqGrid("setColProp", columnName, {widthNew: width});
        },

        /**
         * Vyber sloupecku, ktere chce uzivatel videt v gridu
         *
         * @param grid
         * @param gridName
         */
        saveSettings: function (grid, gridName) {
            var colModel = $(grid).jqGrid('getGridParam', 'colModel');

            // Nacteme si nazvy sloupcu, ktere chceme skryt
            var columns = {};
            $(colModel).each(function (i, col) {
                columns[col.name] = {};
                columns[col.name].ord = i;

                if (typeof col.hidden != 'undefined' && col.hidden == true) {
                    columns[col.name].hidden = true;
                }
                if (typeof col.widthNew != 'undefined') {
                    columns[col.name].width = col.widthNew;
                }
            });

            $.ajax({
                type: 'post',
                url: '/core/grid/save-settings',
                data: {griNam: gridName, col: columns},
                dataType: "json",
                success: function () {
                    $('#' + gridName).trigger('reloadGrid');

                    Lemo_Alert.addSuccess(translate('Settings have been successfully saved'), 'gridSaveSettinsSuccess');
                },
                error: function () {
                    Lemo_Alert.addDanger(translate('Saving has failed'), 'gridSaveSettinsError');
                }
            });
        }
    }
}
